import Checkbox from '@mui/material/Checkbox';
import * as _ from 'lodash';
import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import Flex from '../../../generic/Flex';

const ProjectLoadingRow: VoidFunctionComponent = () => {
  return (
    <div className="project-loading-row">
      <Checkbox
        checked={false}
        disabled
      />
      <div className="project-loading-row__content-loader">
        <ContentLoader
          width="100%"
          height="40px"
        >
          <rect x="0" y="0" rx="3" ry="3" width="100%" height="20" />
          <rect x="0" y="28" rx="3" ry="3" width="80%" height="12" />
        </ContentLoader>
      </div>
    </div>
  );
};

type Props = { count: number };

const LoadingProjectsTableBody = ({ count }: Props) => {
  return (
    <div className="projects-table__body" data-test-id="projects-table-loading">
      <Flex direction="column" grow="1">
        {_.times(count, () => <ProjectLoadingRow />)}
      </Flex>
    </div>
  );
};

export default LoadingProjectsTableBody;
